<template>
  <div class="tabs-demo">
    <ErrorModal />
    <DxTabPanel
      class="ai-tabs"
      styling-mode="secondary"
      tabs-position="top"
      icon-position="start"
      :defer-rendering="true"
      @selection-changed="handleItemClick"
      width="100%"
    >
      <template v-for="tab in tabs" :key="tab.id">
        <DxItem :title="tab.text" icon-position="start">
          <component :is="loadComponent(tab.text, tab.id)" />
        </DxItem>
      </template>
    </DxTabPanel>
  </div>
</template>
<script setup>
import { ref, defineAsyncComponent, markRaw } from "vue";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";

import ErrorModal from "../components/ai-tabs-components/ErrorModal.vue";
const tabs = ref([
  {
    id: 0,
    text: "Configuration"
  },
  { id: 1, text: "Statistics" },
  { id: 2, text: "Logs" },
  { id: 3, text: "Users" },
  { id: 4, text: "Customers" }
]);
const componentCache = new Map();

const loadComponent = componentName => {
  if (!componentCache.has(componentName)) {
    componentCache.set(
      componentName,
      markRaw(
        defineAsyncComponent(() =>
          import(`../components/ai-tabs-components/${componentName}Tab.vue`)
        )
      )
    );
  }
  return componentCache.get(componentName);
};

const handleItemClick = e => {
  const selectedIndex = e.component.option("selectedIndex");

  if (
    typeof selectedIndex !== "number" ||
    selectedIndex < 0 ||
    selectedIndex >= tabs.value.length
  ) {
    return;
  }

  const selectedTab = tabs.value[selectedIndex];

  if (!selectedTab) {
    return;
  }
};
</script>

<style>
.tabs-demo {
  display: flex;
}

.strict-width {
  max-width: 340px;
}

.dx-theme-generic .strict-width {
  max-width: 250px;
}

.widget-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  width: 100%;
  min-width: 200px;
  padding: 16px 32px;
  overflow: clip;
}

.widget-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 80px;
  width: 100%;
}

.widget-wrapper-vertical {
  width: 100%;
  flex-direction: row;
  align-items: center;
}

.options {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding: 20px;
  background-color: rgba(191, 191, 191, 0.15);
}

.caption {
  font-weight: 500;
  font-size: 18px;
}

#show-navigation-buttons {
  margin-top: 22px;
}

.option {
  margin-top: 20px;
}

.dx-tabs {
  max-width: 100%;
}

.dx-tabs-vertical {
  height: 216px;
}

.dx-viewport:not(.dx-theme-generic) .dx-tabs-horizontal {
  border-block-end: 1px solid rgb(225, 225, 225, 0.4);
}

.dx-viewport:not(.dx-theme-generic) .dx-tabs-vertical {
  height: 232px;
  border-inline-end: 1px solid rgb(225, 225, 225, 0.4);
}
</style>
